<div class="containerpadding">
  <div class="d-flex justify-content-center">
    <mat-card appearance="outlined" class="col-12">
      <mat-card-title>{{poruka}} radnog naloga</mat-card-title>

      <form (ngSubmit)="addNalog()">
        <mat-card-content>
          <mat-form-field *ngIf="data.radniNalogId==0" appearance="fill" class="col-12">
            <mat-label>Organizacijska jedinica</mat-label>
            <mat-select [(value)]="data.pjedinica" name="pjedinica">
              <mat-option *ngFor="let jedinica of jedinice" [value]="jedinica.sifra">
                {{jedinica.sifra}} {{jedinica.naziv}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngIf="data.radniNalogId==0" appearance="fill" class="col-12 col-lg-6">
            <mat-label>Vrsta naloga</mat-label>
            <mat-select [(value)]="data.vrstaNaloga" name="level">
              <mat-option *ngFor="let vrsta of vrste" [value]="vrsta.sifra">
                {{vrsta.sifra}} {{vrsta.naziv}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill" class="col-12 col-lg-6">
            <mat-label>Primatelj</mat-label>
            <mat-select [(value)]="data.serviser" name="level">
              <mat-option *ngFor="let serviser of serviseri" [value]="serviser.sifra">
                {{serviser.sifra}} {{serviser.naziv}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill" class="col-12">
            <mat-label>Vrsta rada</mat-label>
            <mat-select [(value)]="data.kvar" name="level">
              <mat-option *ngFor="let kvar of kvarovi" [value]="kvar.sifra">
                {{kvar.sifra}} {{kvar.naziv}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill" class="col-12 col-lg-6">
            <mat-label>Datum</mat-label>
            <input matInput type="date-local" [matDatepicker]="dp1" placeholder="Odaberite datum" [ngModel]="data.datum | date:'yyyy-MM-dd'" (ngModelChange)="data.datum=$event" name="datum">
            <mat-datepicker-toggle matIconSuffix [for]="dp1"></mat-datepicker-toggle>
            <mat-datepicker #dp1></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="fill" class="col-12 col-lg-6">
            <mat-label>Datum prijave</mat-label>
            <input matInput type="date-local" [matDatepicker]="dp2" placeholder="Odaberite datum prijave" [ngModel]="data.datumPrijave | date:'yyyy-MM-dd'" (ngModelChange)="data.datumPrijave=$event" name="datumPrijave">
            <mat-datepicker-toggle matIconSuffix [for]="dp2"></mat-datepicker-toggle>
            <mat-datepicker #dp2></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="fill" class="col-12">
            <mat-label>Opis kvara</mat-label>
            <textarea matInput placeholder="Opis kvara" [(ngModel)]="data.opisKvara" name="opisKvara"></textarea>
          </mat-form-field>
          <korisnik-select (podaci)="OdabirKorisnika($event)"></korisnik-select>

          <mat-form-field appearance="fill" class="col-lg-6 col-12">
            <mat-label>Ime</mat-label>
            <input matInput placeholder="Ime" [(ngModel)]="data.ime" name="ime">
          </mat-form-field>
          <mat-form-field appearance="fill" class="col-lg-6 col-12">
            <mat-label>Prezime</mat-label>
            <input matInput placeholder="Prezime" [(ngModel)]="data.prezime" name="prezime">
          </mat-form-field>
          <mat-form-field appearance="fill" class="col-lg-6 col-12">
            <mat-label>Ulica</mat-label>
            <input matInput placeholder="Ulica" [(ngModel)]="data.ulica" name="ulica">
          </mat-form-field>
          <mat-form-field appearance="fill" class="col-lg-6 col-12">
            <mat-label>Mjesto</mat-label>
            <input matInput placeholder="Mjesto" [(ngModel)]="data.mjesto" name="mjesto">
          </mat-form-field>
          <mat-form-field appearance="fill" class="col-12">
            <mat-label>Skladište</mat-label>
            <mat-select [(value)]="data.jedinica" name="level">
              <mat-option *ngFor="let skladiste of skladista" [value]="skladiste.sifra">
                {{skladiste.sifra}} {{skladiste.naziv}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill" class="col-12">
            <mat-label>Izvršeni radovi</mat-label>
            <textarea matInput placeholder="Izvršeni radovi" [(ngModel)]="data.izvrsenOpisKvara" name="izvrsenOpisKvara"></textarea>
          </mat-form-field>
        </mat-card-content>
        <mat-card-actions class="d-flex justify-content-center">
          <button mat-button type="submit" class="ok-color"><mat-icon aria-hidden="false" aria-label="Snimi">done</mat-icon> Snimi</button>
          <button mat-button (click)="goBack()" type="button" class="cancel-color"><mat-icon aria-hidden="false" aria-label="Odustani">close</mat-icon> Odustani</button>
        </mat-card-actions>

        <div class="form-group">
          <img *ngIf="loading" class="pl-2" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
        </div>
        <div *ngIf="error" class="alert alert-danger">{{error}}</div>
      </form>
      <p>
        <label [ngClass]="status == 'Uspješno dodan' ? 'badge badge-success': 'badge badge-danger'">{{status}}</label>
      </p>

    </mat-card>
  </div>
</div>
